<template>
  <div class="file-detail-container" v-show="data">
    <div class="container-left file-page-container">
      <div class="file-image-box">
        <img v-if="data.isImg" class="file-image" :src="data.url" fit="contain" />
        <div v-else class="file-image file-icon" :class="`file-icon-${data.ext}`"> </div>
      </div>
      <div class="file-info">
        <p v-if="data.file.name||data.fileName" class="info-item"><span class="item-label">名称：</span>{{data.file.name||data.fileName}}</p>
        <p v-if="data.fileName" class="info-item"><span class="item-label">原名称：</span>{{originFileName(data.fileName)}}</p>
        <p v-if="data.file.size" class="info-item"><span class="item-label">文件大小：</span>{{`${data.file.size} 字节（${getSize(data.file.size)}）`}}</p>
        <p v-if="data.url" class="info-item"><span class="item-label">CDN地址：</span>
          <a :title="data.url" class="cdn-address text-overflow-ellipsis" href="javascript:;" v-clipboard:copy="data.url" v-clipboard:success="onCopy">{{limitString(data.url,90)}}</a>
        </p>
      </div>
    </div>
    <div class="container-right">
      <div class="file-info">
        <p v-if="data.realName" class="info-item"><span class="item-label">上传人员：</span>{{`${data.realName}（${data.userName}）`}}</p>
        <p v-if="data.dept" class="info-item"><span class="item-label">所在部门：</span>{{data.dept}}</p>
        <p v-if="data.mobile" class="info-item"><span class="item-label">联系方式：</span>{{data.mobile}}</p>
        <p v-if="data.createTime" class="info-item"><span class="item-label">上传时间：</span>{{formatTime(data.createTime)}}</p>
        <p v-if="data.updateTime" class="info-item"><span class="item-label">修改时间：</span>{{formatTime(data.updateTime)}}</p>
        <p v-if="data.apiSource" class="info-item"><span class="item-label">文件来源：</span>{{data.apiSource}}</p>
      </div>
      <div class="upload-file">
        <el-upload name="file_data" :data="{path,overload,name}" class="upload" ref="upload" :auto-upload="false" drag action="/api/replaceCosFile" :file-list="fileList" :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeUpload" :on-change="handleChange" :on-success="handleSuccess" :on-error="handleError">
          <i class="el-icon-upload upload-icon"></i>
          <div class="el-upload__text">点击或拖拽此处替换该文件</div>
        </el-upload>
      </div>
    </div>
    <div class="container-bottom">
      <el-button type="danger" :disabled="!canSubmit" @click="onSubmit(true)">替换且刷新CDN</el-button>
      <el-button type="primary" :disabled="!canSubmit" @click="onSubmit(false)">仅替换文件</el-button>
      <el-button @click="closeHandle">关闭弹窗</el-button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getFileSize } from '@/common/utils/size.js';
import { limitString } from '@/common/utils/limit.js';
import merge from 'webpack-merge';
export default {
  props: {
    data: {
      type: Object,
      default: {}
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checked: false,
      overload: false,
      fileList: [],
      name: '',
    }
  },
  computed: {
    // 能否提交
    canSubmit () {
      return this.fileList.length > 0;
    }
  },
  methods: {
    limitString (str, limit) {
      return limitString(str, limit)
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 获取文件大小
    getSize (size) {
      if (size !== '-') {
        return getFileSize(size);
      } else {
        return size;
      }
    },
    // 获取原文件名称
    originFileName (name) {
      return this.sub(name, '/');
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    handleRemove (file, fileList) {
      this.fileList = [];
    },
    handlePreview (file) {
      console.log(file);
    },
    beforeUpload (file, fileList) {
      if (this.sub(file.name, '.') === this.sub(this.data.file.name, '.')) {
        return true;
      } else {
        this.$message.warning('替换文件与原文件文件类型不一致，无法替换文件！');
        return false;
      }
    },
    handleChange (file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess (res) {
      if (res.success) {
        this.$message.success(res.data.message);
        this.$emit('getDirectoryFiles');
        this.$nextTick(() => {
          this.$router.push({
            query: merge(this.$route.query, { 'name': this.data.fileName })
          })
        })
      } else {
        this.$message.warning(res.data.message);
      }
      this.closeHandle();
    },
    handleError () {
      this.$message.error('发生了未知的错误，文件上传失败了哦~');
      this.closeHandle();
    },
    sub (name, char) {
      return name.substring(name.lastIndexOf(char) + 1, name.length);
    },
    // 手动上传
    onSubmit (overload) {
      this.$refs.upload.data.name = this.data.file.name;
      this.$refs.upload.data.overload = overload;
      if (overload) {
        this.$confirm(`刷新CDN地址会导致以前的CDN地址失效，请问确定要刷新吗？`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.$refs.upload.submit();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        this.$refs.upload.submit();
      }
    },
    // 关闭弹窗
    closeHandle () {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss">
.file-detail-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  .container-left {
    width: 50%;
    .file-image-box {
      display: flex;
      align-items: center;
      height: 180px;
      .file-image {
        max-width: 100%;
        max-height: 180px;
        border-radius: 6px;
        &.file-icon {
          width: 100%;
          max-height: 180px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: left !important;
        }
      }
    }
  }
  .container-right {
    .upload-file {
      .upload {
        .el-upload-dragger {
          height: 110px;
          .upload-icon {
            margin: 10px 0;
          }
          text-align: center;
        }
      }
    }
  }
  .container-left,
  .container-right {
    .file-info {
      .info-item {
        width: 100%;
        text-align: left;
        color: #718096;
        white-space: nowrap;
        .cdn-address {
          // width: calc(100% - 72px);
          word-break: normal;
          word-wrap: normal;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
  .container-bottom {
    width: 100%;
    margin-top: 20px;
    text-align: right;
  }
}
</style>